<template>
  <div style="-webkit-user-select:none;">

    <share></share>

    <div class="userBG">
      <svg-icon icon-class="signInBG" style="height: 115px;width: 287px;position: absolute;right: 0"></svg-icon>
      <div class="headPortrait" @click="$store.state.SignedIn?goModify():goLogin()">
        <svg-icon icon-class="hPBG" style="height: 50px;width: 50px"
                  v-if="headImage===''||$store.state.SignedIn===false"></svg-icon>
        <div class="headImg" v-if="$store.state.SignedIn && headImage!==''">
          <img :src="headImage" style="height: 50px;width: 50px;border-radius: 50%">
        </div>
      </div>
      <div class="userName" @click="$store.state.SignedIn?goModify():goLogin()">{{
          $store.state.SignedIn ? userName : '登录/注册'
        }}
      </div>
    </div>


    <div class="menu van-hairline--bottom" v-for="(item,index) in menu"
         @click="$store.state.SignedIn || index ===2 || index ===3?jump(index):checkGoLogin()">
      <div class="icon">
        <svg-icon :icon-class="item.icon" style="height: 20px;width: 20px"></svg-icon>
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="arrow">
        <svg-icon icon-class="detailArrow" style="height: 13px;width: 8px"></svg-icon>
      </div>
    </div>


    <div style="width: 100%;padding: 0 25px;box-sizing: border-box;margin-top: 50px" v-if="$store.state.SignedIn">
      <div class="exit" @click="logout">退出</div>
    </div>


  </div>
</template>

<script>
import Share from "@/components/public/share";

export default {
  name: "account",
  components: {Share},
  data() {
    return {
      loginPhone: '',
      userName: '',
      headImage: '',
      id: '',
      menu: [
        {
          title: '我的收藏',
          icon: 'collection'
        },
        {
          title: '我的订阅',
          icon: 'subscribe'
        },
        {
          title: '分享好友',
          icon: 'ShareFriends'
        },
        {
          title: '联系客服',
          icon: 'service'
        },
      ],
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    getLoginInfo() {
      this.loginPhone = localStorage.getItem('mobile')
      this.userName = localStorage.getItem('nickName')
      this.headImage = localStorage.getItem('headImg') || ''

    },
    //注销
    logout() {
      localStorage.setItem('member_uuid', '')
      localStorage.setItem('api_token', '')
      localStorage.setItem('mobile', '')
      localStorage.setItem('nickName', '')
      localStorage.setItem('headImg', '')
      this.getLoginInfo();
      this.$store.state.SignedIn = !!localStorage.getItem(' member_uuid');


      let query = this.$encrypt(this.$genQuery({
        member_uuid: localStorage.getItem('member_uuid'),
        api_token: localStorage.getItem('api_token')
      }))
      this.$post(this.$store.state.apiUrl + '/member/login_out', {qdata: query}).then(res => {
        this.$toast(res.msg);
      }).catch(err => {
        console.log(err)
      })

    },

    jump(index) {
      switch (index) {
        case 0:
          this.$router.push('/collection')
          break;
        case 1:
          this.$router.push('/subscribe')
          break;
        case 2:
          this.$store.state.shareShow = true
          break;
        case 3:
          this.$callPhone(this)
          break;

      }
    },
    goModify() {
      this.$router.push('/modify')
    },
    checkGoLogin() {
      this.$toast('请先登录');
      this.goLogin()


    },

  },
  mounted() {
    this.getLoginInfo()


  }
}
</script>

<style scoped>
.userBG {
  height: 115px;
  width: 100%;
  background-color: #1875f7;
  position: relative;
  display: flex;
  align-items: center;
}


.headPortrait {
  position: absolute;
  left: 25px;
  border-radius: 50%;
  cursor: pointer;
}

.headImg {


}

.userName {
  position: absolute;
  margin-left: 100px;
  color: white;
  font-weight: bolder;
  font-size: 22px;
  cursor: pointer;
}

.menu {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}

.icon {
  position: absolute;
  left: 25px;
}

.title {
  position: absolute;
  color: #323440;
  font-size: 17px;
  left: 70px;
}

.arrow {
  position: absolute;
  right: 25px;
}

.exit {
  height: 50px;
  width: 100%;
  box-sizing: border-box;
  background-color: #e6f0ff;
  color: #1875f7;
  font-size: 16px;
  font-weight: bolder;
  display: flex;
  justify-content: center;
  align-items: center;

}


</style>
